// Vendor libraries
import { EventEmitter, SimpleChanges } from '@angular/core';
// Interfaces / types
import { PaginationControls } from 'NewAngular/features/components/pagination/pagination.constants';
import * as i0 from "@angular/core";
import * as i1 from "../../../directives/disabled/disabled.directive";
import * as i2 from "../../../directives/icon/icon.directive";
/**
 * Simple Pagination Controls Component
 *
 * This component provides generic functionality for pagination controls/buttons
 * that are commonly used in components that display large lists of items.
 * It contains Next/Previous buttons and does not include First/Last
 *
 * Input Properties
 *  paginationInfo: PaginationInfo object used for computing the new page when a button is clicked
 *
 * Output Properties
 *  pageChangeHandler: EventEmitter that emits the new page number after the page has been changed
 *
 */
export class SimplePaginationControlsComponent {
    constructor() {
        this.pageChangeHandler = new EventEmitter();
        this.PAGE_CONTROLS = PaginationControls;
        this.pageNum = 1;
    }
    ngOnInit() {
        if (this.paginationInfo) {
            this.pageNum = this.paginationInfo.current_page_num;
        }
    }
    ngOnChanges(changes) {
        if (changes.paginationInfo?.currentValue) {
            this.pageNum = changes.paginationInfo.currentValue.current_page_num;
        }
    }
    isFirst() {
        return this.pageNum === 1;
    }
    isLast() {
        return this.pageNum >= this.paginationInfo.num_pages;
    }
    getPaginationString() {
        return `Page ${this.paginationInfo.current_page_num} of ${this.paginationInfo.num_pages}`;
    }
    getResultsString() {
        return `${this.paginationInfo.num_items} result${this.paginationInfo.num_items === 1 ? '' : 's'}`;
    }
    /**
     * Uses the current value of pageNum and the paginationEvent to determine the next page number.
     * @param paginationEvent the pagination button that was clicked
     */
    pageChanged(paginationEvent) {
        let newPageNum;
        switch (paginationEvent) {
            case this.PAGE_CONTROLS.PREV:
                newPageNum = Math.max(this.pageNum - 1, 1);
                break;
            case this.PAGE_CONTROLS.NEXT:
                newPageNum = Math.min(this.pageNum + 1, this.paginationInfo.num_pages);
                break;
            default:
                newPageNum = 1;
        }
        this.pageNum = newPageNum;
        this.pageChangeHandler.emit(this.pageNum);
    }
}
SimplePaginationControlsComponent.ɵfac = function SimplePaginationControlsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SimplePaginationControlsComponent)(); };
SimplePaginationControlsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SimplePaginationControlsComponent, selectors: [["ycn-simple-pagination-controls"]], inputs: { paginationInfo: "paginationInfo" }, outputs: { pageChangeHandler: "pageChangeHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 12, vars: 6, consts: [[1, "panel-pagination-content"], [1, "panel-pagination-count", "text-small", 3, "innerText"], [1, "divider-vertical", "mr-2"], [1, "divider-vertical"], [1, "panel-action"], ["ycnDisabled", "", 1, "btn", "btn-secondary", 3, "click", "disabled"], ["ycnIcon", "", 3, "name"]], template: function SimplePaginationControlsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1)(2, "div", 2)(3, "div", 1)(4, "div", 3);
        i0.ɵɵelementStart(5, "div", 4)(6, "div", 5);
        i0.ɵɵlistener("click", function SimplePaginationControlsComponent_Template_div_click_6_listener() { return ctx.pageChanged(ctx.PAGE_CONTROLS.PREV); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(7, "svg", 6);
        i0.ɵɵelementEnd()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelement(8, "div", 3);
        i0.ɵɵelementStart(9, "div", 4)(10, "div", 5);
        i0.ɵɵlistener("click", function SimplePaginationControlsComponent_Template_div_click_10_listener() { return ctx.pageChanged(ctx.PAGE_CONTROLS.NEXT); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(11, "svg", 6);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("innerText", ctx.getResultsString());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("innerText", ctx.getPaginationString());
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", ctx.isFirst());
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-back");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", ctx.isLast());
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-collapse");
    } }, dependencies: [i1.DisabledDirective, i2.IconDirective], encapsulation: 2 });
